<template>
    <div id="taxes">
        <b-row class="backInfoMain2">

            <s-menuSave :msg="sendMsg" newBtn :btnSaveDisabled="checkAllField" @new="menuNew()" saveBtn @save="menuSave()" deleteBtn @delete="menuDelete(activeObj.id)"></s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <div>
                    <!--Affichage de la liste-->
                    <b-row>
                        <s-itemList 
                            v-if="getTaxes"
                            style="width: 100%" 
                            :content="getTaxes" 
                            :returnValue.sync="activeObj" 
                            :showField="$STL('country')" 
                            :showFieldAux="$STL('state')" 
                            activeField="isActive" 
                            :selectedItems="activeObj">
                        </s-itemList>

                    </b-row>                            
                </div>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de centre-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="3">
                <!--{{fromApi}}<br><br><br>-->
                <!--{{activeObj}}<br><br><br>
                {{activeObj.taxesConfigGL.glFCredit}}-->
                
                <span v-if="activeObj.id">
                    <!--TAXE FEDERAL-->
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <div class="itemMain">
                                <div class="itemSubTitle">{{$t('tax_Federal')}}</div>
                                <div class="itemContain">
                                    <!--TITRE DES COLONNES-->
                                    <b-row class="bold" style="margin-bottom: 6px; margin-top: 0px">
                                        <b-col cols="4">{{$t('tax_Nom')}}</b-col>
                                        <b-col cols="4">{{$t('tax_Taux')}}</b-col>
                                    </b-row>
                                    <!--INFO-->
                                    <b-row>
                                        <b-col cols="4">{{activeObj.nameF}}</b-col>
                                        <b-col cols="4">{{activeObj.taxes_rate[0].rateF}} %</b-col>
                                    </b-row>

                                    <!--Taux antérieur-->
                                    <span v-if="activeObj.taxes_rate.length > 1">
                                        <b-row style="margin-left: 15px; margin-right: -26px">
                                            <b-col cols="12" class="subTitle4">
                                                {{$t('tax_TauxPrecedent')}}
                                            </b-col>
                                        </b-row>

                                        <!--taux-->
                                        <span v-for="(taxe, index) in activeObj.taxes_rate" :key="taxe.index">
                                            <b-row v-if="index > 0">
                                                    <b-col cols="4">{{$gShortDate(activeObj.taxes_rate[index].endDate)}}</b-col>
                                                    <b-col cols="4">{{activeObj.taxes_rate[index].rateF}} %</b-col>
                                            </b-row>
                                        </span>
                                    </span>

                                    <!--NUMERO DE TAXE-->
                                    <b-row style="margin-top: 10px;">
                                        <b-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
                                            <s-input 
                                                myClass="txtPrincipal" 
                                                id="description1" 
                                                name="description1" 
                                                autocomplete="off"
                                                type="text" 
                                                maxlength="25" 
                                                :placeholder="$t('tax_NumeroDeTaxe')" 
                                                v-model="activeObj.taxesConfigGL.numberF">
                                            </s-input>
                                        </b-col>
                                    </b-row>
                                    <!--GL PERÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Percu')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glFCredit"></compteAutoComplete>
                                        </b-col>
                                    </b-row>
                                    <!--GL PAYÉ-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Paye')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glFDebit"></compteAutoComplete>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <!--FIN - TAXE FEDERAL-->

                    <!--TAXE PROVINCIAL-->
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <div class="itemMain">
                                <div class="itemSubTitle">{{$t('tax_Provincial')}}</div>
                                <div class="itemContain">
                                    <!--TITRE DES COLONNES-->
                                    <b-row class="bold" style="margin-bottom: 6px; margin-top: 0px">
                                        <b-col cols="4">{{$t('tax_Nom')}}</b-col>
                                        <b-col cols="4">{{$t('tax_Taux')}}</b-col>
                                    </b-row>
                                    <!--INFO-->
                                    <b-row>
                                        <b-col cols="4">{{activeObj.nameP}}</b-col>
                                        <b-col cols="4">{{activeObj.taxes_rate[0].rateP}} %</b-col>
                                    </b-row>

                                    <!--Taux antérieur-->
                                    <span v-if="activeObj.taxes_rate.length > 1">
                                        <b-row style="margin-left: 15px; margin-right: -26px">
                                            <b-col cols="12" class="subTitle4">
                                                {{$t('tax_TauxPrecedent')}}
                                            </b-col>
                                        </b-row>

                                        <!--taux-->
                                        <span v-for="(taxe, index) in activeObj.taxes_rate" :key="taxe.index">
                                            <b-row v-if="index > 0">
                                                    <b-col cols="4">{{$gShortDate(activeObj.taxes_rate[index].endDate)}}</b-col>
                                                    <b-col cols="4">{{activeObj.taxes_rate[index].rateP}} %</b-col>
                                                    <b-col cols="4">{{$FM(activeObj.taxes_rate[index].amountP, 2)}}</b-col>
                                            </b-row>
                                        </span>
                                    </span>

                                    <!--NUMERO DE TAXE-->
                                    <b-row style="margin-top: 10px;">
                                        <b-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
                                            <s-input
                                                class="txtPrincipal" 
                                                id="description1" 
                                                name="description1" 
                                                autocomplete="off"
                                                type="text" 
                                                maxlength="25" 
                                                :placeholder="$t('tax_NumeroDeTaxe')" 
                                                v-model="activeObj.taxesConfigGL.numberP">
                                            </s-input>
                                        </b-col>
                                    </b-row>
                                    <!--PERÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Percu')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glPCredit"></compteAutoComplete>
                                        </b-col>
                                    </b-row>
                                    <!--REÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Paye')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glPDebit"></compteAutoComplete>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <!--FIN - TAXE PROVINCIAL-->

                    <!--TAXE D'HÉBERGEMENT-->
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <div class="itemMain">
                                <div class="itemSubTitle">{{$t('tax_TaxeDhebergement')}}</div>
                                <div class="itemContain">
                                    <!--TITRE DES COLONNES-->
                                    <b-row class="bold" style="margin-bottom: 6px; margin-top: 0px">
                                        <b-col cols="4">{{$t('tax_Nom')}}</b-col>
                                        <b-col cols="4">{{$t('tax_Taux')}}</b-col>
                                    </b-row>
                                    <!--INFO-->
                                    <b-row>
                                        <b-col cols="4">{{$t('tax_TaxeDhebergement')}}</b-col>
                                        <b-col cols="4">{{activeObj.taxes_rate[0].rateMotel}} %</b-col>
                                    </b-row>

                                    <!--Taux antérieur-->
                                    <span v-if="activeObj.taxes_rate.length > 1">
                                        <b-row style="margin-left: 15px; margin-right: -26px">
                                            <b-col cols="12" class="subTitle4">
                                                {{$t('tax_TauxPrecedent')}}
                                            </b-col>
                                        </b-row>

                                        <!--taux-->
                                        <span v-for="(taxe, index) in activeObj.taxes_rate" :key="taxe.index">
                                            <b-row v-if="index > 0">
                                                    <b-col cols="4">{{$gShortDate(activeObj.taxes_rate[index].endDate)}}</b-col>
                                                    <b-col cols="4">{{activeObj.taxes_rate[index].hebergeRate}} %</b-col>
                                            </b-row>
                                        </span>
                                    </span>

                                    <!--NUMERO DE TAXE-->
                                    <b-row style="margin-top: 10px;">
                                        <b-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
                                            <s-input
                                                class="txtPrincipal" 
                                                id="description1" 
                                                name="description1" 
                                                autocomplete="off"
                                                type="text" 
                                                maxlength="25" 
                                                :placeholder="$t('tax_NumeroDeTaxe')" 
                                                v-model="activeObj.taxesConfigGL.numberHeberge">
                                            </s-input>
                                        </b-col>
                                    </b-row>
                                    <!--PERÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Percu')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glMotelCredit"></compteAutoComplete>
                                        </b-col>
                                    </b-row>
                                    <!--REÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Paye')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glMotelDebit"></compteAutoComplete>
                                            <!--<br><br><b-button @click="configTaxes.glHebergeCr = ''">test</b-button>
                                            <br><br>{{configTaxes.glHebergeCr}}-->
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <!--FIN - TAXE D'HÉBERGEMENT-->

                    <!--TAXE PNEUS-->
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <div class="itemMain">
                                <div class="itemSubTitle">{{$t('tax_Pneu')}}</div>
                                <div class="itemContain">
                                    <!--TITRE DES COLONNES-->
                                    <b-row class="bold" style="margin-bottom: 6px; margin-top: 0px">
                                        <b-col cols="4">{{$t('tax_Nom')}}</b-col>
                                        <b-col cols="4">{{$t('tax_Taux')}}</b-col>
                                    </b-row>
                                    <!--INFO-->
                                    <b-row>
                                        <b-col cols="4">{{$t('tax_Pneu')}}</b-col>
                                        <b-col cols="4">{{activeObj.taxes_rate[0].rateTire}} %</b-col>
                                    </b-row>

                                    <!--Taux antérieur-->
                                    <span v-if="activeObj.taxes_rate.length > 1">
                                        <b-row style="margin-left: 15px; margin-right: -26px">
                                            <b-col cols="12" class="subTitle4">
                                                {{$t('tax_TauxPrecedent')}}
                                            </b-col>
                                        </b-row>

                                        <!--taux-->
                                        <span v-for="(taxe, index) in activeObj.taxes_rate" :key="taxe.index">
                                            <b-row v-if="index > 0">
                                                    <b-col cols="4">{{$gShortDate(activeObj.taxes_rate[index].endDate)}}</b-col>
                                                    <b-col cols="4">{{activeObj.taxes_rate[index].hebergeRate}} %</b-col>
                                            </b-row>
                                        </span>
                                    </span>

                                    <!--NUMERO DE TAXE-->
                                    <b-row style="margin-top: 10px;">
                                        <b-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
                                            <s-input
                                                class="txtPrincipal" 
                                                id="description1" 
                                                name="description1" 
                                                autocomplete="off"
                                                type="text" 
                                                maxlength="25" 
                                                :placeholder="$t('tax_NumeroDeTaxe')" 
                                                v-model="activeObj.taxesConfigGL.numberTire">
                                            </s-input>
                                        </b-col>
                                    </b-row>
                                    <!--PERÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Percu')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glTireCredit"></compteAutoComplete>
                                        </b-col>
                                    </b-row>
                                    <!--REÇU-->
                                    <b-row align-v="center">
                                        <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4" align="right" class="bold">{{$t('tax_Paye')}}</b-col>
                                        <b-col cols="8" xs="8" sm="8" md="8" lg="4" xl="4">
                                            <compteAutoComplete :vmodel.sync="activeObj.taxesConfigGL.glTireDebit"></compteAutoComplete>
                                            <!--<br><br><b-button @click="configTaxes.glHebergeCr = ''">test</b-button>
                                            <br><br>{{configTaxes.glHebergeCr}}-->
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <!--FIN - TAXE PNEUS-->
                
                </span>

            </b-col>
            <!--FIN - Section de centre-->

            <!--Section de droite-->
            <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                <!--{{fromApi}}-->
                <!--{{getTaxes}}-->
                <!--{{configTaxes}}-->
            </b-col>
            <!--FIN - Section de droite-->

            <br><br>
            
        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';

export default{
    name: "taxes",
    components: {

    },
    data() {
        return{
            apiAddGet1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiTaxes, //adress de la requete principale vers l'API
            apiAddPost1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiTaxes, //adress de la requete principale vers l'API
            apiAddGet2: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiTaxesConfigGL, //adress de la requete principale vers l'API
            apiAddPost2: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiTaxesConfigGL, //adress de la requete principale vers l'API
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            fromApi: null, //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            InitialStateConfigTaxes: null, //Format initial de : activeObj
            //Objet en cours de modification
            activeObj:{
                id: 0,
                codeTax: '',
                dateCreer: null,
                dateModif: null,
                actif: true,
                nameF: '',
                nameP: '',
                countryFr: '',
                countryEn: '',
                stateFr: '',
                stateEn: '',
                taxes_rate: [{
                    id: 0,
                    codeTax: '',
                    isActive: true,
                    dateCreated: null,
                    dateModified: null,
                    startDate: null,
                    endDate: null,
                    rateF: 0,
                    rateP: 0,
                    rateMotel: 0,
                    rateTire: 0
                }],
                taxesConfigGL: {
                    codeTax: '',
                    numberF: '',
                    glFDebit: '',
                    glFCredit: '',
                    numberP: '',
                    glPDebit: '',
                    glPCredit: '',
                    numberMotel: '',
                    glMotelDebit: '',
                    glMotelCredit: '',
                    numberTire: '',
                    glTireDebit: '',
                    glTireCredit: ''
                }
            },
        }
    },
    methods: {
        ttt(aaa){
            alert(aaa)
        },
        pushto(link) {
            this.$router.push(link)
        },
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            //this.configTaxes = this.$CObj(this.InitialStateConfigTaxes)
        },
        menuNew(){
            this.resetAll()
        },
        loadApi() {
            this.sendMsg = '4'
            axios.get(this.apiAddGet1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(response => {
                  this.$store.dispatch('updateTaxes', response.data)
                  //this.fromApi = response.data
                  this.sendMsg = ''
                })
                .catch(e => {
                  this.errors.push(e)
                  this.sendMsg = '2'
                })
        },
        menuSave(){
            this.sendMsg = '-'
            let currentObj = this;
            let t = this.activeObj.taxesConfigGL

            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                axios.post(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    id: t.id,
                    codeTax: t.codeTax,
                    numberF: t.numberF,
                    glFDebit: t.glFDebit,
                    glFCredit: t.glFCredit,
                    numberP: t.numberP,
                    glPDebit: t.glPDebit,
                    glPCredit: t.glPCredit,
                    numberMotel: t.numberMotel,
                    glMotelDebit: t.glMotelDebit,
                    glMotelCredit: t.glMotelCredit,
                    numberTire: t.numberTire,
                    glTireDebit: t.glTireDebit,
                    glTireCredit: t.glTireCredit
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                axios.patch(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    id: t.id,
                    codeTax: t.codeTax,
                    numberF: t.numberF,
                    glFDebit: t.glFDebit,
                    glFCredit: t.glFCredit,
                    numberP: t.numberP,
                    glPDebit: t.glPDebit,
                    glPCredit: t.glPCredit,
                    numberMotel: t.numberMotel,
                    glMotelDebit: t.glMotelDebit,
                    glMotelCredit: t.glMotelCredit,
                    numberTire: t.numberTire,
                    glTireDebit: t.glTireDebit,
                    glTireCredit: t.glTireCredit
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });


            }
                setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    this.output = null
                    let currentObj = this;
                    axios.delete(this.apiAdd1 + '?' + this.apiAddPost1 + '&licence=' + this.$store.getters.getworkLicence + '&id=' + id + '&status=false', {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                    .then(function (response) {
                        currentObj.sendMsg = '1'
                        currentObj.output = response.data;
                    })
                    .catch(function (error) {
                        currentObj.sendMsg = '2'
                        currentObj.output = error;
                    });

                    setTimeout(() => { this.sendMsg = '' }, 5000)

                }
        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress', 'getApiAdd', 'getPageSize', 'getworkLicence', 'getApiKey', 'getCombo', 'getCheckSize', 'getLanguage', 'getTaxes']),
        checkAllField() {
            if (this.activeObj.id == '' || this.activeObj.id == null || this.activeObj.id == '0')
            {return true}
            else
            {return false}
            //return false
        }
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        //this.loadApi() //charger les licences
        this.InitialState = this.$CObj(this.activeObj)
        //this.InitialStateConfigTaxes = this.$CObj(this.configTaxes)
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                this.loadApi()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>